module.exports = () => {
  return [
    {
      name: '标签ID',
      value: 'label_id',
    },
    {
      name: '标签',
      value: 'name',
    },
    {
      name: '渠道标签ID',
      value: 'channel_label_id',
    },
  ];
};
